module.exports = __webpack_public_path__ + "static/media/arrow-detail.f622c250.svg";